<template>
  
    <div class="left_menu_wrapper" v-if="leftMenuVisible && winW >1024">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
        <div class="veil" @click="hideLeftMenu"></div>
      </transition>
      <div class="menu left_menu on">
        <div class="container">
          <div class="menu_close" @click="hideLeftMenu"></div>
          <ul class="langs">
            <li data-lang="ru" :class="{'active': $i18n.locale === 'ru'}">
              <a href="javascript:;" hreflang="ru" target="_top" @click="setLang('ru')">ru</a>
            </li>
            <li data-lang="ua" :class="{'active': $i18n.locale === 'ua'}">
              <a href="javascript:;" hreflang="uk" target="_top" @click="setLang('ua')">ua</a>
            </li>
          </ul>
          <div class="menu_logo">
            <svg width="210" height="105" xmlns:xlink="http://www.w3.org/1999/xlink">
              <defs>
                <path id="a" d="M0 .09h209.987v104.74H0z"/>
              </defs>
              <g fill="none" fill-rule="evenodd">
                <g>
                  <mask id="b" fill="#fff">
                    <use xlink:href="#a"/>
                  </mask>
                  <path d="M209.987.09C154.95 23.598 55.037 23.598 0 .09l17.499 87.28c44.632 23.233 126.984 23.325 174.989 0L209.987.09z" fill="red" mask="url(#b)"/>
                </g>
                <path fill="#FFF" d="M49.285 40l-3.342 19.17-.225 1.288h-.436l-.223-1.278L41.715 40 35 40.005V75h5.192l.021-10.34-.445-11.697h.418L44.131 75h2.738l3.945-22.037h.418l-.445 11.696V75H56V40.005zM70.26 40l-.143 28.877c0 1.517-1.41 1.868-2.117 1.868-.796 0-2.117-.351-2.117-1.868L65.74 40H60l.475 27.557C60.475 72.42 62.268 75 68 75s7.525-2.581 7.525-7.443L76 40h-5.74zM85.228 70.636V40H80v35h11v-4.364zM138.362 70.636V40H133v35h11v-4.364zM157 44.364V40h-11v35h10.925v-4.364h-5.655V57.58h4.216v-4.364h-4.216v-8.852zM104 40H89v4.21h4.741V75h5.518V44.21H104zM107 75h5V40h-5zM125.287 53.821c0 1.363-.301 2.613-2.578 2.613h-.996V44.362h1.407c2.44 0 2.167 1.565 2.167 2.928v6.531zm-1.623-13.818L116 40v35h5.713V60.83h2.14c4.803 0 7.147-2.412 7.147-6.17v-8.13c0-3.758-1.733-6.527-7.336-6.527zM174.646 40h-5.56l-2.37 13.027h-.432L163.914 40h-5.56l3.51 15.071L158 75h5.764l2.013-12.028.51-5.735h.422l.515 5.735L169.199 75H175l-3.863-19.929z"/>
              </g>
            </svg>
          </div>
          <div class="mob_container">
            <div class="menu_list">
              <a href="https://multiplex.ua" class="menu_item">{{ $t("pop_ups.left_menu.now_in_cinema") }}</a>
              <a href="https://multiplex.ua/soon" class="menu_item">{{ $t("pop_ups.left_menu.soon") }}</a>
              <a :href="getPopcornLink()" class="menu_item yellow">{{ $t("pop_ups.left_menu.buy_popcorn_online") }}</a>
              <a href="https://multiplex.ua/promotions" class="menu_item">{{ $t("pop_ups.left_menu.promos") }}</a>
              <a href="https://multiplex.ua/cinemas" class="menu_item">{{ $t("pop_ups.left_menu.cinemas") }}</a>
              <a href="https://multiplex.ua/faq" class="menu_item">{{ $t("pop_ups.left_menu.faq") }}</a>
              <a href="https://multiplex.ua/about" class="menu_item">{{ $t("pop_ups.left_menu.about") }}</a>
            </div>
          </div>
            <div class="menu-block">
            <div class="menu-block-heading">
              {{ $t("pop_ups.left_menu.personal") }}
            </div>
            <a :href="logoutURL" class="menu-block-btn" rel="nofollow"><svg style="transform: rotate(180deg)" viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><path d="M0 0h30v30H0z"/><path d="M15.064 9.614a1 1 0 0 0 .229 1.093L18.586 14H8a1 1 0 1 0 0 2h10.586l-3.293 3.293a1 1 0 1 0 1.414 1.414l4.912-4.912a1 1 0 0 0-.002-1.592l-4.91-4.91a1 1 0 0 0-1.643.321z" fill="#FFF" fill-rule="nonzero"/></g></svg>{{ $t("pop_ups.left_menu.logout") }}</a>
          </div>
          <div class="menu-block">
            <div class="menu-block-heading">{{ $t("pop_ups.left_menu.assist") }}</div>
            <a class="menu-block-phone" href="tel:0 800 505 333"><svg width="24" height="24">
              <g fill="none" fill-rule="evenodd">
                <path d="M0 0h24v24H0z"/>
                <path d="M11 2C8.803 2 7 3.803 7 6s1.803 4 4 4 4-1.803 4-4-1.803-4-4-4zm0 2c1.116 0 2 .884 2 2s-.884 2-2 2-2-.884-2-2 .884-2 2-2zm0 9c-3.141 0-9 1.546-9 4.5V20h9.277c.152-.684.36-1.354.633-2H4v-.5c0-.869 3.708-2.5 7-2.5.838 0 1.701.105 2.525.277.26-.326.532-.641.827-.94.254-.25.521-.489.796-.714C13.683 13.21 12.157 13 11 13zm11.443 0a9.544 9.544 0 0 0-6.685 2.76A9.542 9.542 0 0 0 13 22.443c0 .374.313.557.557.557h1.949c.302 0 .55-.24.556-.543.008-.35.03-.79.079-1.068.053-.301.157-.663.236-.918a.566.566 0 0 0-.143-.567l-.664-.72C15.571 19.184 16 18 17 17c1-1 2.232-1.479 2.232-1.479l.672.715a.565.565 0 0 0 .567.141c.254-.079.617-.183.918-.236.278-.05.718-.07 1.068-.078a.557.557 0 0 0 .543-.557v-1.95a.552.552 0 0 0-.557-.556z" fill="#FFF" fill-rule="nonzero"/>
              </g>
            </svg>0 800 505 333</a>
          </div>
          		<div class="menu-block">
			<div class="menu-block-heading">{{ $t("pop_ups.left_menu.socials") }}</div>
			<div class="menu_soc">
				<!-- <a href="http://vk.com/uamultiplex" target="_blank" class="menu_soc_item">Vkontakte</a> -->
				<a href="https://www.facebook.com/uamultiplex" target="_blank" rel="nofollow" class="menu_soc_item"><svg width="24" height="24">
					<g fill="none" fill-rule="evenodd">
						<path d="M0 0h24v24H0z"/>
						<path d="M12 2C6.489 2 2 6.489 2 12s4.489 10 10 10 10-4.489 10-10S17.511 2 12 2zm0 2c4.43 0 8 3.57 8 8a7.977 7.977 0 0 1-6.781 7.898v-5.513h2.328l.365-2.365H13.22v-1.293c0-.983.32-1.856 1.24-1.856h1.477V6.807c-.26-.035-.81-.112-1.846-.112-2.166 0-3.436 1.144-3.436 3.75v1.575H8.428v2.365h2.226v5.494A7.978 7.978 0 0 1 4 12c0-4.43 3.57-8 8-8z" fill="#FFF" fill-rule="nonzero"/>
					</g>
				</svg>
					Facebook</a>
				<a href="https://www.youtube.com/user/MultiplexChannel" target="_blank" rel="nofollow" class="menu_soc_item">
					<svg width="24" height="24">
						<g fill="none" fill-rule="evenodd">
							<path d="M0 0h24v24H0z"/>
							<path d="M12 4s-6.254 0-7.814.418a2.503 2.503 0 0 0-1.768 1.768C2 7.746 2 12 2 12s0 4.254.418 5.814c.23.861.908 1.538 1.768 1.768C5.746 20 12 20 12 20s6.254 0 7.814-.418a2.505 2.505 0 0 0 1.768-1.768C22 16.254 22 12 22 12s0-4.254-.418-5.814a2.505 2.505 0 0 0-1.768-1.768C18.254 4 12 4 12 4zm0 2c2.882 0 6.49.134 7.297.35a.508.508 0 0 1 .353.353c.241.898.35 3.639.35 5.297s-.109 4.398-.35 5.297a.508.508 0 0 1-.353.353c-.805.216-4.415.35-7.297.35-2.881 0-6.49-.134-7.297-.35a.508.508 0 0 1-.353-.353C4.109 16.399 4 13.658 4 12s.109-4.399.35-5.299a.505.505 0 0 1 .353-.351C5.508 6.134 9.118 6 12 6zm-2 2.535v6.93L16 12l-6-3.465z" fill="#FFF" fill-rule="nonzero"/>
						</g>
					</svg>
					Youtube</a>
				<a href="https://www.instagram.com/multiplex_official/" target="_blank" rel="nofollow" class="menu_soc_item">
					<svg width="24" height="24">
						<g fill="none" fill-rule="evenodd">
							<path d="M0 0h24v24H0z"/>
							<path d="M8 3C5.243 3 3 5.243 3 8v8c0 2.757 2.243 5 5 5h8c2.757 0 5-2.243 5-5V8c0-2.757-2.243-5-5-5H8zm0 2h8c1.654 0 3 1.346 3 3v8c0 1.654-1.346 3-3 3H8c-1.654 0-3-1.346-3-3V8c0-1.654 1.346-3 3-3zm9 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-5 1c-2.757 0-5 2.243-5 5s2.243 5 5 5 5-2.243 5-5-2.243-5-5-5zm0 2c1.654 0 3 1.346 3 3s-1.346 3-3 3-3-1.346-3-3 1.346-3 3-3z" fill="#FFF" fill-rule="nonzero"/>
						</g>
					</svg>
					Instagram</a>
			</div>
		</div>
        </div>
      </div>
    </div>
  
</template>
<script>
import Store from '../../store'
export default {
  computed: {
    leftMenuVisible: function () {
      return Store.state.leftMenuVisible
    },
    winW: function () {
      return Store.state.winW
    },
    logoutURL: function () {
      return Store.state.logoutURL
    }
  },
  methods: {
    hideLeftMenu: function () {
      Store.commit('hideLeftMenu')
    },
    setLang: function (lang) {
      Store.commit('setLang', lang)
      this.$i18n.locale = lang
      this.$cookie.set('uLang', lang, {expires: 365, domain: '.multiplex.ua'})
      this.hideLeftMenu()
      document.title = this.$t('commons.title')
    },
    getPopcornLink: function () {
      let cinemaN = this.$cookie.get('cinemaN')
      let link = 'https://multiplex.ua'
      if (cinemaN) {
        link = 'https://new.multiplex.ua/order/cinema/' + cinemaN + '/concession'
      }
      return link
    }
  }
}
</script>



// WEBPACK FOOTER //
// left-menu.vue?1beff7e0